import { Button } from '@nazka/nazka.mapframe.components';
import { faClose } from '@fortawesome/pro-solid-svg-icons';

import EditMobilityOffer from '@App/components/EditMobilityOffer/EditMobilityOffer';

import './mobility-plan-edit-modal.styl'

const loading = false;

function MobiltyPlanEditModal({ setShowEditModal, companyId, OIDN }) {
  return (
    <div className="mobilty-plan-edit-modal">
      <div
        className="mobilty-plan-edit-modal__background"
        onClick={() => setShowEditModal(false)}
      />
      <div className={`mobilty-plan-edit-modal__content${loading ? ' is-loading' : ''}`}>
        <div className="mobilty-plan-edit-modal__content__header">
          <div className="mobilty-plan-edit-modal__content__header__title">
            Mobiliteitsaanbod aanpassen
          </div>
          <Button
            icon={faClose}
            layout="ghost"
            hover={false}
            className="mobilty-plan-edit-modal__content__header__close"
            onClick={() => setShowEditModal(false)}
          />
        </div>
        <div className="mobilty-plan-edit-modal__content__body">
          <EditMobilityOffer
            companyId={companyId}
            onCancel={() => setShowEditModal(false)}
            isAdmin={false}
            OIDN={OIDN}
          />
        </div>
      </div>
    </div>
  )
}

export default MobiltyPlanEditModal;